import { Link } from 'react-router-dom';
import { Waypoints } from 'lucide-react';
import { useOrgRoutes } from '@/lib/useOrgRoutes';

interface StreamFlowCellProps {
  flowName: string;
  flowRunId: string | null;
}

/**
 * Agent-column cell for an agentless usage stream that a flow run owns. Names
 * the responsible flow (linking to its run when the id is known) instead of
 * the generic "flow / no agent" placeholder.
 */
export function StreamFlowCell({ flowName, flowRunId }: StreamFlowCellProps) {
  const orgRoutes = useOrgRoutes();
  const label = (
    <>
      <Waypoints className="icon-sm shrink-0 text-muted-foreground" />
      <span className="max-w-[220px] truncate font-medium">{flowName}</span>
    </>
  );
  return flowRunId ? (
    <Link to={orgRoutes.flowRun(flowRunId)} className="flex items-center gap-2 hover:underline">
      {label}
    </Link>
  ) : (
    <span className="flex items-center gap-2">{label}</span>
  );
}
